module.exports = __webpack_public_path__ + "static/img/template.7cdb7e6a.png";